import Button from '@components/_atoms/Button';
import Modal from '@components/_atoms/Modal';
import Typography from '@components/_atoms/Typography';
import { ButtonColor, TypoVariant } from '@constants/atoms';
import ButtonCode from '@constants/log/buttonCode';
import styled from '@emotion/styled';

type Props = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly handleDeleteAll: () => void;
};

const Layout = styled.div`
  display: flex;
  flex-direction: column;
`;
const ButtonSection = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export default function DeleteAllModal({ isOpen, onClose, handleDeleteAll }: Props) {
  return (
    <Modal title="모두 지우기" open={isOpen} handleModalClose={onClose}>
      <Layout>
        <Typography variant={TypoVariant.B4}>내가 선택한 자재를 모두 지울까요?</Typography>
        <ButtonSection>
          <Button
            text="취소"
            width="100%"
            color={ButtonColor.OutlinedBlack}
            onClick={onClose}
            steelbosoId={ButtonCode.BTN_CANCEL}
          />
          <Button
            text="삭제하기"
            width="100%"
            color={ButtonColor.OutlinedRed}
            onClick={handleDeleteAll}
            steelbosoId={ButtonCode.BTN_DELETE}
          />
        </ButtonSection>
      </Layout>
    </Modal>
  );
}
